<template>
  <div class="home">
    <!-- 网站首页的banner -->
    <el-carousel arrow="always">
      <el-carousel-item v-for="(item,index) in bannerList" :key="index">
        <div class="home-banner" :style="{'background-image': `url(${item.img})`}">
          <div class="banner-content">
            <div class="left" :class="item.weizhi === 0 ? 'left_l' : 'left_r'">
              <div>{{item.title}}</div>
              <div v-html="item.intro"></div>
              <a v-if="item.download" class="btn" :href="path + item.name">立即试用</a>
              <div v-else-if="!item.notryBtn" @click="toTry(item.name)">立即试用</div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <ul class="list">
      <!-- 关于我们区域 -->
      <li class="item about" v-if="0">
        <div class="wrapper">
          <div class="left" id="about" :class="animateObj['#about'] ? 'ani' : ''">
            <div class="title"><span>关于我们</span></div>
            <div class="intro">
              <img :src="aboutUs" alt="">
            </div>
            <div class="text">在题库考试、教育软件开发和office处理软件开发上一直保持领先，在行业内有较高知名度。</div>
            <div class="btn">
              <el-button type="warning" @click="toAbout" round icon="el-icon-document">点击查看</el-button>
            </div>
          </div>
        </div>
      </li>
      <!-- 所有产品区域 -->
      <li class="item product">
        <div class="wrapper">
          <el-divider>题库类系统</el-divider>
          <div class="product-item" style="margin-top:60px">
            <div class="left" id="product6-left" :class="animateObj['#product6-left'] ? 'ani' : ''">
              <div class="intro">
                乐分享题库系统 · 个人版
              </div>
              <div class="text">
                适用于所有行业、全部学科快速建立专业题库！ <br>
                支持Word所支持的全部格式。 <br>
                独创把Word嵌入到软件中的功能，在软件中直接使用Word编辑题目，十分方便。 <br>
                提供多个批量入库的Word模板，可以把多种复杂类型的试卷快速批量入库
              </div>
              <div class="btn">
                <a class="el-button--warning" :href="path + './soft/LFX_ExercLib__Personal.rar'">立即下载试用</a>
              </div>
            </div>
            <div class="right" id="product6-right" :class="animateObj['#product6-right'] ? 'ani' : ''">
              <!-- <img :src="product1" alt=""> -->
              <video :poster="p_poster" :src="personalSrc" controls="controls"></video>
            </div>
          </div>
          <div class="product-item style2">
            <div style="margin-right:20px" class="right" id="product4-right" :class="animateObj['#product4-right'] ? 'ani' : ''">
              
              <video class="video2" ref="video2" :poster="cloud_video" :src="cloudSrc" controls="controls"></video>
            </div>
            <div class="left" id="product4-left" :class="animateObj['#product4-left'] ? 'ani' : ''">
              <div class="intro">
                乐分享题库系统 · 网页版
              </div>
              <div class="text">
                适用于所有行业、全部学科快速建立专业题库！ <br>
                支持Word所支持的全部格式。 <br>
                软件支持功能定制，可以根据需求定制个性化版本！
              </div>
              <div class="btn">
                <el-button type="warning" round @click="toTry(tikuUrl)">立即试用</el-button>
              </div>
            </div>
          </div>
          <div class="product-item">
            <div class="left" id="product1-left" :class="animateObj['#product1-left'] ? 'ani' : ''">
              <div class="intro">
                乐分享题库系统 · 网络客户端版
              </div>
              <div class="text">
                适用于所有行业、全部学科快速建立专业题库！ <br>
                支持Word所支持的全部格式。 <br>
                独创把Word嵌入到软件中的功能，在软件中直接使用Word编辑题目，十分方便。 <br>
                提供多个批量入库的Word模板，可以把多种复杂类型的试卷快速批量入库
              </div>
              <div class="btn">
                <a class="el-button--warning" :href="path + './soft/LFX_ExercLib__Net.rar'">立即下载试用</a>
              </div>
            </div>
            <div class="right" id="product1-right" :class="animateObj['#product1-right'] ? 'ani' : ''">
              <video :poster="cs_video" ref="video3" :src="netSrc" controls="controls"></video>
            </div>
          </div>
          <div class="online">
            <el-divider>考试类系统</el-divider>
            <div class="product-item">
            <div class="left" id="product5-left" :class="animateObj['#product5-left'] ? 'ani' : ''">
              <div class="intro">
                乐分享在线考试系统
              </div>
              <div class="text">
                跨平台、多方位的考试系统<br>
                PC、移动端、微信小程序等均可进行考试<br>
                防作弊<br>
              </div>
              <div class="btn">
                <el-button type="warning" round @click="toTry(examUrl)">立即试用</el-button>
              </div>
            </div>
            <div class="right" id="product5-right" :class="animateObj['#product5-right'] ? 'ani' : ''">
              <video class="video2" ref="video4" :poster="exam_video" :src="examSrc" controls="controls"></video>
            </div>
          </div>
          </div>
          <div class="office">
            <el-divider>Office处理</el-divider>
            <div class="product-item style2">
              <div style="margin-right:20px;" class="right" id="product2-right" :class="animateObj['#product2-right'] ? 'ani' : ''">
                <video class="video2"  :poster="word_video" ref="video5" :src="wordSrc" controls="controls"></video>
              </div>
              <div class="left" id="product2-left" :class="animateObj['#product2-left'] ? 'ani' : ''">
                <div class="intro">
                  Word批量<strong>超级</strong>大师
                </div>
                <div class="text">
                  <li>安装即用，及其稳定</li>
                  <li>总计几十大类几百个功能</li>
                  <li>设置好任务后，一键自动处理，无需人工值守，几十万份文件自动处理完成！！！</li>
                  <li>可以任意多个功能组合处理，效率极高</li>
                  <li>只需注册一个账号，就可以在任意一台电脑登录使用！！！</li>
                  <li>无论office还是WPS，无版本要求，在任何一台电脑上安装即用，超级方便！！！</li>
                  <li>本软件速度实测是《Word文档批量处理大师》软件处理速度的20~50倍！！！</li>
                  <li>可以选套餐，也可以按功能付费，可以只购买需要的功能。</li>
                </div>
                <div class="btn">
                  <a class="el-button--warning" :href="path + './soft/BatchWord_Super.zip'">立即下载试用</a>
                </div>
              </div>
             </div>
            <div class="product-item style2">
              <div style="margin-right:20px;" class="right" id="product2-right" :class="animateObj['#product2-right'] ? 'ani' : ''">
                <video class="video2"  :poster="word_video" ref="video5" :src="wordSrc" controls="controls"></video>
              </div>
              <div class="left" id="product2-left" :class="animateObj['#product2-left'] ? 'ani' : ''">
                <div class="intro">
                  Word批量处理大师
                </div>
                <div class="text">
                  试用版一次最多处理6个文件，注册后，推荐一次处理不超出1万个<br>
                  Word文件几十个修改需求，一次就可以完成。
                </div>
                <div class="btn">
                  <a class="el-button--warning" :href="path + './soft/BatchWord.rar'">立即下载试用</a>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="ppt">
            <el-divider>ppt处理</el-divider> -->
            <div class="product-item">
              <div class="left" id="product3-left" :class="animateObj['#product3-left'] ? 'ani' : ''">
                <div class="intro">
                  PPT批量处理大师
                </div>
                <div class="text">
                  一次批量处理最多3万文件几十个功能自由组合<br>
                  一次添加多个处理任务<br>
                  自由升级，无限制
                </div>
                <div class="btn">
                  <a class="el-button--warning" :href="path + './soft/BatchPPT.rar'">立即下载试用</a>
                </div>
              </div>
              <div class="right" id="product3-right" :class="animateObj['#product3-right'] ? 'ani' : ''">
                <video class="video2" :poster="ppt_video" ref="video6" :src="pptSrc" controls="controls"></video>
              </div>
            </div>

          <!-- </div> -->
        </div>
      </li>
      <!-- 在线教程区域 -->
      <li class="item course" v-if="0">
        <div class="wrapper">
            <div style="height:1px"></div>
            <el-divider>在线教程</el-divider>
            <div class="subtitle"><span style="color:#F88927">历经十五年</span>，我们成为移动互联网开发领域先行者</div>
            <div class="course-content">
              <div class="left" id="course-left" :class="animateObj['#course-left'] ? 'ani' : ''">
                <div>轻松使用</div>
                <div>快速了解实际操作方法</div>
                <div>引导用户理解相关产品使用操作方法，向用户传递本产品的特色 功能，向用户介绍产品的实用特性，新用户往往可以通过视频教 程的学习，提高对本产品的熟练程度。</div>
                <div class="btn">
                  <el-button type="warning" round @click="toCourse">查看更多</el-button>
                </div>
              </div>
              <div class="right">
                <ul class="course-list">
                  <li class="course-item" :id="'course-item' + item" :class="animateObj['#course-item' + item] ? 'ani' : ''"  v-for="item in 4" :key="item">
                    <div>
                    </div>
                    <div style="font-size:20px;margin-top:28px">{{item}}题库组卷考试系统<br>(云题库)</div>
                    <div style="font-size:18px;margin-top:18px">题库组卷考试系统适用于 所有行业，全兼容Word 格式，极速批量入库</div>
                  </li>
                </ul>
              </div>
            </div>
        </div>
      </li>
      <!-- 软件下载区域 -->
      <li class="item download" id="download" v-if="0">
        <div class="wrapper">
          <div style="height:1px"></div>
            <el-divider>软件下载</el-divider>
            <div class="subtitle"><span style="color:#F88927">历经十五年</span>，我们成为移动互联网开发领域先行者</div>
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <el-rate disabled v-model="value1"></el-rate>
                  <div>
                    <img :src="diannao" alt="">
                  </div>
                  <div style="font-size:24px;margin: 20px 0">Word文档批量处理大师   9.0.8</div>
                  <div style="color:#8F8F8F;font-size:18px">试用版一次最多处理6个文件</div>
                  <div class="btn" style="margin-top:25px">
                    <a class="el-button--warning" :href="path + './soft/BatchWord.rar'">本地下载</a>
                  </div>
                </div>
                <div class="swiper-slide">
                  <el-rate disabled v-model="value1"></el-rate>
                  <div>
                    <img :src="diannao" alt="">
                  </div>
                  <div style="font-size:24px;margin: 20px 0">PPT批量处理大师   5.2.6</div>
                  <div style="color:#8F8F8F;font-size:18px">一次批量处理3万文件几十个功能</div>
                  <div class="btn" style="margin-top:25px">
                    <a class="el-button--warning" :href="path + './soft/BatchPPT.rar'">本地下载</a>
                  </div>
                </div>
                <div class="swiper-slide">
                  <el-rate disabled v-model="value1"></el-rate>
                  <div>
                    <img :src="diannao" alt="">
                  </div>
                  <div style="font-size:24px;margin: 20px 0">免费题库资源</div>
                  <div style="color:#8F8F8F;font-size:18px">题库免费资源</div>
                  <div class="btn" style="margin-top:25px">
                    <a class="el-button--warning" href="javascript:;" @click="toDown">本地下载</a>
                  </div>
                </div>
              </div>
              <!-- Add Pagination -->
              <div class="swiper-pagination"></div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
        </div>
      </li>
      <!-- <li class="item hezuo">
        <div style="height:1px"></div>
        <el-divider>客户案例</el-divider>
        <div class="kehu-title">网络版及网页版 客户案例：</div>
        <ul class="list">
            <li class="item" v-for="(item,index) in hezuo" :key="index">
                <div class="img">
                    <img :src="item.img" alt="">
                </div>
                <p>{{item.name}}</p>
            </li>
        </ul>
        <div class="kehu-title title2">云题库 客户案例：</div>
        <ul class="list">
            <li class="item" v-for="(item,index) in hezuo2" :key="index">
                <div class="img">
                    <img :src="item.img" alt="">
                </div>
                <p>{{item.name}}</p>
            </li>
        </ul>
      </li> -->
    </ul>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css'
import 'swiper/js/swiper.min.js'
import kehu from './js/hezuoList'
export default {
  name: 'Home',
  data(){
    return {
      tikuUrl: IPConfig.tikuUrl,
      examUrl: IPConfig.examUrl,
      path: process.env.BASE_URL,
      animate: false,
      value1: 5,
      aboutUs: require('@/assets/img_abus.png'),
      product1: require('@/assets/img_2.png'),
      product2: require('@/assets/img_3.png'),
      product3: require('@/assets/img_4.png'),
      product4: require('@/assets/img_5.png'),
      product5: require('@/assets/img_6.png'),
      product6: require('@/assets/img_7.png'),
      sp: require('@/assets/icon_sp.png'),
      diannao: require('@/assets/icon_r.png'),
      leftImg: require('@/assets/icon_zuo.png'),
      rightImg: require('@/assets/icon_you.png'),
      animateObj: {
        // '#about': false,
        '#product1-left': false,
        '#product1-right': false,
        '#product2-left': false,
        '#product2-right': false,
        '#product3-left': false,
        '#product3-right': false,
        '#product4-left': false,
        '#product4-right': false,
        '#product5-left': false,
        '#product5-right': false,
        '#product6-left': false,
        '#product6-right': false,
        // '#course-left': false,
        // '#course-item1': false,
        // '#course-item2': false,
        // '#course-item3': false,
        // '#course-item4': false,
      },
      p_poster: require('../assets/p_video.png'),
      cloud_video: require('../assets/cloud_video.png'),
      cs_video: require('../assets/cs_video.png'),
      exam_video: require('../assets/exam_video.png'),
      word_video: require('../assets/word_video.png'),
      ppt_video: require('../assets/ppt_video.png'),
      bannerList: [
        {
          title: 'Word批量超级大师',
          intro: '总计有27大类，几百个小功能<br>安装即用，处理速度特别快！！！<br>几十万个文件,一键处理，无需人工值守！<br>不限制电脑，在任意一台电脑都可以凭账号密码登录使用！',
          name: './soft/BatchWord_Super.rar',
          download: true,
          img: require('@/assets/home_5.png'),
          weizhi: 1
        },
        {
          // title: '乐分享题库系统 · 网络客户端版',
          // intro: '适用于所有行业；快速批量入库<br>完美兼容Word的全部格式<br>完美支持公式、图形、图片、符号……<br>提供多个批量入库的Word模板',
          name: './soft/LFX_ExercLib__Net.rar',
          download: true,
          img: require('@/assets/home_3.png'),
          weizhi: 0
        },
        {
          // title: '乐分享题库系统 · 网页版',
          // intro: '分享题目有收益<br>基础题库免费送<br>私有题库、共享题库、多人协作<br>针对大团队提供独立私密云空间<br>完美兼容Word的全部格式<br>完美支持公式、图形、图片、符号……<br>集批量上传、编辑、组卷、考试、成绩分析等所有功能于一身',
          name: IPConfig.tikuUrl,
          download: false,
          img: require('@/assets/home_2.png'),
          weizhi: 1
        },
        {
          // title: '乐分享在线考试系统',
          // intro: '跨平台、多方位的考试系统<br>PC、移动端、微信小程序等均可进行考试<br>防作弊；拍照上传',
          name: IPConfig.examUrl,
          download: false,
          img: require('@/assets/home_4.png'),
          weizhi: 1
        },
        {
          notryBtn: true,
          img: require('@/assets/cloud_banner.png'),
          weizhi: 0 //文案是在左边还是右边 左边是0 右边是1
        },
        {
          // title: '乐分享题库系统 · 个人版',
          // intro: '完美兼容Word的全部格式<br>完美支持公式、图形、图片、符号……<br>适用于所有行业；快速批量入库<br>提供多个批量入库的Word模板',
          name: './soft/LFX_ExercLib__Personal.rar',
          download: true,
          img: require('@/assets/home_1.png'),
          weizhi: 0 //文案是在左边还是右边 左边是0 右边是1
        },
        
      ],
      hezuo: kehu.list,
      hezuo2: kehu.list2,
      personalSrc: `${process.env.BASE_URL}video/productIntro/personal.mp4`,
      cloudSrc: `${process.env.BASE_URL}video/productIntro/cloud.mp4`,
      netSrc: `${process.env.BASE_URL}video/productIntro/net.mp4`,
      examSrc: `${process.env.BASE_URL}video/productIntro/exam.mp4`,
      wordSrc: `${process.env.BASE_URL}video/productIntro/word.mp4`,
      pptSrc: `${process.env.BASE_URL}video/productIntro/ppt.mp4`,

    }
  },
  mounted(){
    new Swiper('.swiper-container', {
      slidesPerView: 3,
      spaceBetween: 30,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    var _self = this;
    var videos = document.getElementsByTagName('video');//获取所有video
    //循环给所有video添加监听事件 当前的video开始播时  调用pauseAll 将当前播放的video的索引传值过去
    for (var i = videos.length - 1; i >= 0; i--) {
        (function(n){
            videos[n].addEventListener('play',function(){
                _self.pauseAll(n);
            })
        })(i)
    }
  },
  methods: {
    pauseAll(index){
        var videos = document.getElementsByTagName('video');//获取所有video
        for (var j = videos.length - 1; j >= 0; j--) {
            if (j!=index){
                videos[j].pause();
            }
        }
    },
    toDown(){
        var a = this.$router.resolve({name: 'Free'});
        window.open(a.href);
    },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var w = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      for(var key in this.animateObj){
        var offsetTop = document.querySelector(key).offsetTop;
        if(scrollTop > offsetTop - w + 90){
          this.animateObj[key] = true;
        }else{
          this.animateObj[key] = false;
        }
      }
    },
    toTry(url){
      window.open(url);
    },
    toAbout(){
      this.$router.push({
        name: 'About'
      })
    },
    toCourse(){
      this.$router.push({
        name: 'Course'
      })
    }
  },
  destroyed(){
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style lang="less">
  .ani{
    transform: translateZ(0)!important;
    opacity: 1!important;
  }
  .home{
    .el-carousel__arrow{
      width: 86px;
      height: 86px;
      font-size: 26px;
    }
    .el-carousel__container{
      height: 730px;
    }
    video{
      width: 530px!important;
      height: 340px!important;
    }
    .video2{
      margin-top: -20px;
    }
    .el-carousel__indicator--horizontal{
      .el-carousel__button{
        width: 16px;
        height: 16px;
        border-radius: 50%;
      }
    }
    .home-banner{
      height: 730px;
      background: #198AF7 url('../assets/home_banner@2x.png') no-repeat center center;
      background-size: auto 100%;
      .banner-content{
        width: 1200px;
        position: relative;
        margin: 0 auto;
        height: 100%;
        .left{
          position: absolute;
          bottom: 10px;
          transform: translateY(-50%);
          color: #fff;
          >div{
            &:nth-of-type(1){
              font-size: 40px;
              margin: 8px 0;
            }
            &:nth-of-type(2){
              font-size: 20px;
            }
            &:nth-of-type(3){
              text-align: center;
              font-size: 20px;
              width:150px;
              height:50px;
              line-height: 50px;
              border:1px solid rgba(255,255,255,1);
              border-radius:25px;
              margin-top: 20px;
              cursor: pointer;
              &:hover{
                background-color: #f88927;
                border-color: #f88927;
              }
            }
          }
          .btn{
            display: inline-block;
            text-align: center;
            font-size: 20px;
            width:150px;
            height:50px;
            line-height: 50px;
            border:1px solid rgba(255,255,255,1);
            border-radius:25px;
            margin-top: 20px;
            cursor: pointer;
            color: #fff;
            text-decoration: none;
            &:hover{
              background-color: #f88927;
              border-color: #f88927;
            }
          }
        }
        .left_l{
          left: 0;
        }
        .left_r{
          right: 0;
        }
      }
    }
    .list{
      background-color: #EEEEEE;
      .item{
        background-color: #fff;
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 0;
        }
        .wrapper{
          // width: 1200px;
          margin: 0 auto;
          
        }
      }
      .common{
        .title{
          font-size: 36px;
          color: #444444;
          span{
            vertical-align: middle;
          }
          &::before{
            vertical-align: middle;
            display: inline-block;
            content: '';
            width: 62px;
            height: 58px;
            background: url('../assets/icon_us.png') no-repeat;
            background-size: 100% 100%;
            margin-right: 22px;
          }
        }
        .text{
          color: #8F8F8F;
          font-size: 20px;
          line-height: 36px;
        }
        .btn{
          margin-top: 20px;
          .el-button--warning{
            background-color: #f88927;
          }
          a{
              line-height: 1;
              border-radius: 20px;
              padding: 12px 23px;
              display: inline-block;
              text-decoration: none;
              color: #fff;
              margin-right: 10px;
              margin-bottom: 20px;
              border: 1px solid #DCDFE6;
              font-size: 14px;
              font-weight: 500;
              padding: 12px 23px;
          }
        }
      }
      .about{
        .left{
          width: 330px;
          height: 500px;
          padding: 100px 0 60px 0;
          transition: all 0.6s;
          transform: translate3d(0,100px,0);
          opacity: 0;
          .common();
          .intro{
            margin: 38px 0;
          }
        }
        .wrapper{
          background: url('../assets/img_t.png') no-repeat right center;
        }
      }

      .product{
        .wrapper{
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          padding-top: 86px;
          .common();
          .title{
            text-align: center;
            margin-bottom: 76px;
            &::before{
              width: 0;
              height: 64px;
              background: url('../assets/icon_tpt.png') no-repeat;
              background-size: 100% 100%;
            }
          }
          .product-item{
            width: 1200px;
            box-sizing: border-box;
            padding: 40px;
            box-shadow:0px 0px 15px 0px rgba(108,184,255,0.4);
            border-radius:10px;
            display: flex;
            margin: 0 auto;
            margin-bottom: 100px;
            .left{
              flex: 1;
              transition: all 0.6s;
              transform: translate3d(0,100px,0);
              opacity: 0;
              margin-right: 10px;
              .intro{
                color:#F88927;
                font-size:24px;
                margin: 30px 0;
                margin-top: 0;
              }
            }
            .right{
              flex: 1;
              transition: all 0.6s;
              transform: translate3d(0,120px,0);
              opacity: 0;
              display: flex;
              justify-content: center;
              video{
                width: 100%;
                outline: none;
              }
            }
          }
          .online{
            background:rgba(248,249,250,1);
            padding-top: 76px;
            #product5-left{
              padding-left: 100px;

            }
            .product-item{
              box-shadow: none;
              margin-bottom: 20px;
            }
            .el-divider__text{
              background:rgba(248,249,250,1);
            }
          }
          .office{
            padding-top: 76px;
            .product-item{
              box-shadow: none;
            }
          }
          .ppt{
            #product3-left{
              padding-left: 100px;
            }
            .product-item{
              box-shadow: none;
            }
          }
          .style2{
            .left{
              .text{
                width: 595px;
              }
            }
          }
        }
      }
      .el-divider{
        width: 460px;
        margin: 0 auto;
        margin-bottom: 30px;
        .el-divider__text{
          font-size: 36px;
          color: #444444;
          font-weight: 300;
        }
      }
      .hezuo{
        background:rgba(255,255,255,1);
        padding: 102px 0;
        .kehu-title{
          width: 1200px;
          margin: 0 auto;
          margin-top: 80px;
          color: #444444;
          font-size: 20px;
          margin-bottom: 20px;
        }
        .title2{
          margin-top: 50px;
        }
        .list{
            display: flex;
            flex-wrap: wrap;
            background-color: #fff;
            width: 1200px;
            margin: 0 auto;
            
            .item{
                width: 167px;
                height: 197px;
                padding: 20px;
                box-sizing: border-box;
                background:rgba(255,255,255,1);
                box-shadow:0px 4px 16px 0px rgba(158,158,158,0.4);
                margin-right: 91px;
                margin-bottom: 38px;
                transition: all 0.6s;
                &:nth-of-type(5n){
                    margin-right: 0;
                }
                &:hover{
                    transform: scale(1.1);
                }
                .img{
                    width: 100px;
                    height: 100px;
                    margin: 0 auto;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                p{
                    margin-top: 5px;
                    text-align: center;
                    width: 100%;
                    // overflow: hidden;
                    // text-overflow: ellipsis;
                    // white-space: nowrap;
                }
            }
        }
      }
      .course{
        background-color: #F2FAFF;
        .wrapper{
          padding: 102px 0;
          .subtitle{
            font-size: 18px;
            text-align: center;
            margin-bottom: 30px;
            color: #8F8F8F;
            margin: 28px 0 58px 0;
          }
          .el-divider__text{
            background-color: #F2FAFF;
            font-size: 36px;
            color: #444444;
            font-weight: 300;
          }
          .course-content{
            display: flex;
            justify-content: space-between;
            .left{
              width: 520px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              transition: all 0.6s;
              transform: translate3d(0,100px,0);
              opacity: 0;
              >div{
                &:nth-of-type(1){
                  color: #F88927;
                  font-size: 36px;
                  margin: 10px 0;
                }
                &:nth-of-type(2){
                  color: #3B3B3B;
                  font-size: 36px;
                }
                &:nth-of-type(3){
                  color: #767676;
                  font-size: 18px;
                  margin: 40px 0;
                }
              }
            }
            .right{
              width: 540px;
            }
          }
          .course-list{
            display: flex;
            flex-wrap: wrap;
            .course-item{
              width: 240px;
              border-radius:3px;
              box-shadow:0px 0px 8px 0px rgba(108,184,255,0.4);
              background-color: #fff;
              box-sizing: border-box;
              text-align: center;
              padding: 20px;
              margin-right: 30px;
              margin-bottom: 30px;
              cursor: pointer;
              transition: all 0.6s;
              transform: translate3d(0,100px,0);
              opacity: 0;
              &:nth-of-type(2n-1){
                position: relative;
                top: 50px;
              }
              >div{
                &:nth-of-type(1){
                  background: url('../assets/icon_jc.png') no-repeat center center;
                  height: 42px;
                }
                &:nth-of-type(3){
                  color:#8F8F8F;
                }
              }
              &:hover{
                background:rgba(40,152,247,1);
                position: relative;
                transform: scale(1.04);
                transition: all 0.6s;
                color: #fff;
                >div{
                  &:nth-of-type(1){
                    background: url('../assets/icon_b.png') no-repeat center center;
                  }
                  &:nth-of-type(3){
                    color:#fff;
                  }
                }
              }
            }
          }
        }
      }
      .download{
        padding: 102px 0;
        .wrapper{
          position: relative;
          .swiper-button-prev,.swiper-button-next{
            &:focus{
              outline: none;
            }
          }
        }
        
        .subtitle{
          font-size: 18px;
          text-align: center;
          margin-bottom: 30px;
          color: #8F8F8F;
          margin: 28px 0 0px 0;
        }
        .el-divider__text{
          font-size: 36px;
          color: #444444;
          font-weight: 300;
        }
        .swiper-container{
          // padding-bottom: 60px;
          padding: 60px 30px;
          box-sizing: border-box;
          width: 1100px;
          .swiper-slide{
            text-align: center;
            box-sizing: border-box;
            padding: 30px 0;
            height: 376px;
            border-radius:4px;
            cursor: pointer;
            a{
                border-radius: 20px;
                padding: 12px 23px;
                display: inline-block;
                text-decoration: none;
                color: #fff;
                margin-right: 10px;
                margin-bottom: 20px;
                background-color: #f88927;
                &:hover{
                    opacity: 0.7;
                }
            }
            .el-rate{
              text-align: left;
              margin-bottom: 40px;
              margin-left: 30px;
              .el-icon-star-on:before{
                font-size: 24px;
              }
            }
            &:hover{
              border: 1px solid #49BDEE;
              transition: all 0.6s;
              transform: scale(1.04);
              box-shadow:0px 5px 10px 0px rgba(1,138,206,0.3)
            }
          }
        }
      }
    }
  }
</style>
